<template>
<div class="chapter">
<div class="inner_page">
<div class="lgc">
<h1 class="line"><span class="gesp">L I N N E T</span></h1>
<p class="line1"></p>
<p class="line2"><span class="it"><span class="bold"><span class="gesp">A  R O M A N C E</span></span></span></p>
<p class="line1"></p>
<p class="line2"><span class="gesp"><span class="it">By</span></span> <span class="gesp">GRANT ALLEN</span></p>
<p class="line1"></p>
<p class="line3"><span class="it1">Author of</span> “UNDER SEALED ORDERS,”</p>
<p class="line3">“MISS CAYLEY’S ADVENTURES,” ETC.</p>
<p class="line1"></p>
<p class="line1"></p>
<p class="line1"><span class="calibre2">NOTE</span><br class="calibre1"/></p>
</div>
<div class="literal-container">
<div class="literal">
<p class="line4">This story was written in the midst of the scenery which</p>
<p class="line4">it describes; but the author desires to acknowledge his</p>
<p class="line4">obligations for many touches of local colour to Mr.</p>
<p class="line4">Baillie-Grohman’s admirable work on “Tyrol and the</p>
<p class="line4">Tyrolese.” The quatrain on p. 283 is quoted, with</p>
<p class="line4">some slight modifications (to adapt it to its place</p>
<p class="line4">in this novel), from a poem by Mr. William Watson.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?7b1da937